import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import '../styles/Signup.css'; // CSS file
import userProfileService from '../firebase_func/subCollections/userProfile';
import { auth, db } from '../firebase_func/firebase';
import { createUserWithEmailAndPassword } from 'firebase/auth';

const Signup = () => {
  // Set up form state to track the values for each input field
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    birthday: '',
    country: '',
    state: '',
    city: '',
    email: '',
    organization: '',
    password: '',
    confirmPassword: ''
  });
  // Set up Error Message
  const [errorMessage, setErrorMessage] = useState('');

  // Set up Navigation
  const navigate = useNavigate();

  // Function to handle changes to each input field and update the form state
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });

  //Gives the user realtime tracking that checks if the passwords match
  if(name === "password" || name === 'confirmPassword'){
    if (formData.password !== value && name === 'confirmPassword'){
      setErrorMessage('Passwords do not match');
    } else if (name === 'password ' && formData.confirmPassword && value !== formData.confirmPassword){
      setErrorMessage('Passwords do not match');
    } else {
      setErrorMessage('');
    }
  }
};

  

  // Function to handle form submission (e.g., send data to an API)
  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent the default form submission
    if (formData.password !== formData.confirmPassword){
      setErrorMessage('Passwords do not match.');
      return;
    }
    try {
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        formData.email,
        formData.password
      );
    
      const user = userCredential.user;
    
      // Create User Profile subcollection with provided fields
      await userProfileService.createUserProfile(user.uid, {
        firstName: formData.firstName,
        lastName: formData.lastName,
        organization: formData.organization,
        email: formData.email,
        city: formData.city,
        state: formData.state,
        country: formData.country,
        dob: formData.birthday,
        joinDate: new Date().toISOString(),
        freeTrialEndDate: new Date(Date.now() + 14 * 24 * 60 * 60 * 1000).toISOString() // 14 days later
      });
    
      // Redirect to the Payment page after successful signup
   // navigate('/payment');
      navigate('/notebookHome');
    } catch (error) {
      setErrorMessage(error.message);
      console.error('Signup error:', error);
    }
    
  };

  return (
    <div className="signup-container">
      {/* Page title */}
      <h1 className="signup-title">Sign up</h1>
      
      {/* Form start */}
      <form onSubmit={handleSubmit} className="signup-form">
        
        {/* Name fields (First and Last) */}
        <div className="signup-row">
          <div className="signup-input-group">
            <label>First</label>
            <input
              type="text"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              className="signup-input"
              placeholder="First"
            />
          </div>
          <div className="signup-input-group">
            <label>Last</label>
            <input
              type="text"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              className="signup-input"
              placeholder="Last"
            />
          </div>
        </div>

        {/* Birthday and Location fields */}
        <div className="signup-row">
          <div className="signup-input-group">
            <label>Birthday</label>
            <input
              type="date"
              name="birthday"
              value={formData.birthday}
              onChange={handleChange}
              className="signup-input"
            />
          </div>
          <div className="signup-input-group">
            <label>Location</label>
            <div className="signup-row">
              <input
                type="text"
                name="country"
                value={formData.country}
                onChange={handleChange}
                className="signup-input"
                placeholder="Country"
              />
              <input
                type="text"
                name="state"
                value={formData.state}
                onChange={handleChange}
                className="signup-input"
                placeholder="State"
              />
              <input
                type="text"
                name="city"
                value={formData.city}
                onChange={handleChange}
                className="signup-input"
                placeholder="City/Town"
              />
            </div>
          </div>
        </div>

        {/* Email field */}
        <div className="signup-input-group">
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="signup-input"
            placeholder="Email"
          />
        </div>

        {/* Organization field  */}
        <div className="signup-input-group">
          <input
            type="text"
            name="organization"
            value={formData.organization}
            onChange={handleChange}
            className="signup-input"
            placeholder="Organization (optional)"
          />
        </div>

        {/* Password and Confirm Password fields */}
        <div className="signup-input-group">
          <input
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            className="signup-input"
            placeholder="Password"
          />
        </div>
        <div className="signup-input-group">
          <input
            type="password"
            name="confirmPassword"
            value={formData.confirmPassword}
            onChange={handleChange}
            className="signup-input"
            placeholder="Re-enter password"
          />
        </div>

        {/* Error Message */}
        {errorMessage && <p className="signup-error-text">{errorMessage}</p>}

        {/* Submit button */}
        <button type="submit" className="signup-submit-button">Sign Up</button>
      </form>

      {/* Link to login page for users who already have an account */}
      <p className="signup-footer-text">
        Already have an account? <a href="/login">Login</a>
      </p>
    </div>
  );
};

export default Signup;
